import { useNavigate } from 'react-router';

import { SoftwareOnboardingHeader, SoftwareOnboardingProgress } from 'src/components/SoftwareOnboarding';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { useNotificationsSuggestChanges } from 'src/context/suggest-changes';
import { ExitAlertDialog } from 'src/pages/SoftwareEscrowRequestChanges/ui';

const Header = () => {
  const { steps, currentStep } = useNotificationsSuggestChanges();
  const navigate = useNavigate();
  const {
    softwareEscrow: { id },
  } = useSoftwareEscrow();

  const onDiscardChanges = () => navigate(`/software-escrows/${id}/settings/technical`);

  return (
    <SoftwareOnboardingHeader justify="end">
      {steps.length > 1 && (
        <SoftwareOnboardingProgress
          currentStep={currentStep + 1}
          completedStep={steps.length}
          totalSteps={steps.length}
        />
      )}
      <ExitAlertDialog onDiscard={onDiscardChanges} />
    </SoftwareOnboardingHeader>
  );
};

export default Header;
